/* ============================================================
   Patch 13.4 — scroll-reveal
   Adds .is-visible to [data-ts-reveal] elements as they enter
   the viewport. Also auto-tags known Topscent section blocks so
   we don't have to edit every liquid template. Respects
   prefers-reduced-motion (CSS handles the no-motion fallback).
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Elements we want to reveal, grouped so we can stagger children.
  // selector = the group container(s); childSelector = items to stagger inside it.
  var GROUPS = [
    { group: '.ts-focus__head', child: null },
    { group: '.ts-focus__track', child: '.ts-focus__card' },
    { group: '.topscent-comparison__inner', child: null },
    { group: '.topscent-comparison__table', child: null },
    { group: '.topscent-faq__copy', child: null },
    { group: '.topscent-faq__accordion', child: null },
    { group: '.ts-quiz__intro', child: null },
    { group: '.ts-lifestyle__inner', child: null },
    { group: '.ts-gallery__head', child: null },
    { group: '.ts-gallery__grid', child: '.ts-gallery__item' }
  ];

  function tag(el, delay) {
    if (!el || el.hasAttribute('data-ts-reveal')) return;
    el.setAttribute('data-ts-reveal', '');
    if (delay) el.style.setProperty('--ts-reveal-delay', delay + 's');
  }

  function autoTag() {
    GROUPS.forEach(function (g) {
      document.querySelectorAll(g.group).forEach(function (container) {
        if (g.child) {
          var kids = container.querySelectorAll(g.child);
          kids.forEach(function (kid, i) {
            tag(kid, Math.min(i * 0.08, 0.4));
          });
        } else {
          tag(container, 0);
        }
      });
    });
  }

  function run() {
    autoTag();

    var targets = document.querySelectorAll('[data-ts-reveal]');
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
